module.exports = __webpack_public_path__ + "static/media/guest-collection-website-bg.e382db47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/guest-collection-website-bg.jpg
// module id = 2373
// module chunks = 71